import { useQuery } from '@tanstack/react-query';
import { getPlatformStatistics } from '@/api/platformStatistics';
import type { PlatformStatistics } from '@/types/platformStatistics';

export function usePlatformStatistics() {
  return useQuery<PlatformStatistics>({
    queryKey: ['platformStatistics'],
    queryFn: () => getPlatformStatistics(),
    staleTime: 10 * 1000,
  });
}

